import http from '../http.js'
import {
  AUDIO_CLEANER_PAGE_TASK_TYPE,
  AUDIO_PAGE_TASK_TYPES,
  buildAudioCleanerCreatePayload,
} from '~/constants/audioCleanerSettings.js'

export const AudioCleanerApi = {
  CREATE_TASK: '/api/aigc/audio/audio-generation/create-task',
  GET_TASK_RESULT: '/api/aigc/audio/audio-generation/get-task-result',
  GET_HISTORY: '/api/aigc/audio/audio-generation/get-history',
  DELETE_TASK: '/api/aigc/audio/audio-generation/delete-task',
}

/** Trim / noise-reduction path (legacy underscore). */
export const AUDIO_CLEANER_TASK_TYPE = 'audio_cleaner'
export const AUDIO_CLEANER_GENERATION_TYPE = 'audio_cleaner'
export const AUDIO_CLEANER_COIN_TYPE = 'gold_coin'

const PAGE_TASK_TYPE_SET = new Set(AUDIO_PAGE_TASK_TYPES)

/** Repeat array keys: task_type=a&task_type=b (not task_type[]=a). */
function serializeHistoryQuery(params) {
  const parts = []
  for (const [key, value] of Object.entries(params)) {
    if (value == null || value === '') continue
    if (Array.isArray(value)) {
      for (const item of value) {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`)
      }
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    }
  }
  return parts.length ? `?${parts.join('&')}` : ''
}

/**
 * Create audio cleaner / enhancer task.
 * - Trim denoise: pass only `{ audio_url, duration }` → task_type `audio_cleaner`
 * - Product page: pass settings / task_type `audio-cleaner` | `audio-enhancer`
 * @param {{
 *   audio_url: string,
 *   duration: number,
 *   settings?: Record<string, boolean>,
 *   task_type?: string,
 * }} params
 */
export function createAudioCleanerTask(params) {
  const {
    audio_url,
    duration,
    settings,
    task_type,
  } = params || {}

  const usePagePayload =
    PAGE_TASK_TYPE_SET.has(task_type) ||
    (settings && Object.keys(settings).length > 0)

  if (usePagePayload) {
    return http.post(
      AudioCleanerApi.CREATE_TASK,
      buildAudioCleanerCreatePayload({
        audio_url,
        duration,
        settings,
        task_type: task_type || AUDIO_CLEANER_PAGE_TASK_TYPE,
      }),
    )
  }

  return http.post(AudioCleanerApi.CREATE_TASK, {
    task_type: AUDIO_CLEANER_TASK_TYPE,
    audio_url,
    duration,
    generation_type: AUDIO_CLEANER_GENERATION_TYPE,
    coin_type: AUDIO_CLEANER_COIN_TYPE,
  })
}

/** @param {{ task_id: string }} params */
export const getAudioCleanerTaskResult = (params) =>
  http.get(AudioCleanerApi.GET_TASK_RESULT, params)

/**
 * @param {{
 *   page?: number,
 *   size?: number,
 *   task_type?: string | string[],
 * }} [params]
 */
export function getAudioCleanerHistory(params = {}) {
  const query = {
    page: Number(params.page) || 1,
    size: Number(params.size) || 10,
    task_type: params.task_type ?? AUDIO_CLEANER_PAGE_TASK_TYPE,
  }
  return http.get(`${AudioCleanerApi.GET_HISTORY}${serializeHistoryQuery(query)}`)
}

/** @param {{ task_ids: string[] }} data */
export const deleteAudioCleanerTask = (data) =>
  http.post(AudioCleanerApi.DELETE_TASK, data)
